import { render, staticRenderFns } from "./SubMenuLaudos.vue?vue&type=template&id=9043e9b8&"
import script from "./SubMenuLaudos.vue?vue&type=script&lang=js&"
export * from "./SubMenuLaudos.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports